import React from 'react';
import S from '../../../../commons/components/style/HowSafeDealWorksModal';
import MoneyRefund from '../../../../commons/components/icons/MoneyRefund';
import MagnifierSearchYellow from '../../../../commons/components/icons/MagnifierSearchYellow';
import PackageWithIssue from '../../../../commons/components/icons/PackageWithIssue';
import DeliveryVan from '../../../../commons/components/icons/DeliveryVan';
import HelpLifeline from '../../../../commons/components/icons/HelpLifeline';
import { useI18n } from '../../../../i18n';

export const BuyerModalBody = () => {
  const i18n = useI18n();
  const step2Title = i18n`dlv_safedeal_info_modal_description_2_pt1_buyer`;

  return (
    <S.ModalBody data-testid="how-sd-works-modal-body">
      <S.ListItem>
        <S.ListItemImage>
          <MagnifierSearchYellow width="32" height="32" viewBox="0 0 140 140" />
        </S.ListItemImage>
        <S.ListItemParagraph>
          <strong>{i18n`dlv_safedeal_info_modal_description_1_pt1_buyer`}</strong>{' '}
          {i18n`dlv_safedeal_info_modal_description_1_pt2_buyer`}
        </S.ListItemParagraph>
      </S.ListItem>
      <S.ListItem>
        <S.ListItemImage>
          <PackageWithIssue width="32" height="32" viewBox="0 0 130 102" />
        </S.ListItemImage>
        <S.ListItemParagraph>
          <strong>{step2Title}</strong> {i18n`dlv_safedeal_info_modal_description_2_pt2_buyer`}
        </S.ListItemParagraph>
      </S.ListItem>
      <S.ListItem>
        <S.ListItemImage>
          <DeliveryVan width="32" height="32" viewBox="0 0 130 100" />
        </S.ListItemImage>
        <S.ListItemParagraph>
          <strong>{i18n`dlv_safedeal_info_modal_description_3_pt1_buyer`}</strong>{' '}
          {i18n`dlv_safedeal_info_modal_description_3_pt2_buyer`}
        </S.ListItemParagraph>
      </S.ListItem>
      <S.ListItem>
        <S.ListItemImage>
          <HelpLifeline width="32" height="32" viewBox="0 0 120 120" />
        </S.ListItemImage>
        <S.ListItemParagraph>
          <strong>{i18n`dlv_safedeal_info_modal_description_4_pt1_buyer`}</strong>{' '}
          {i18n`dlv_safedeal_info_modal_description_4_pt2_buyer`}
        </S.ListItemParagraph>
      </S.ListItem>
    </S.ModalBody>
  );
};

export const SellerModalBody = () => {
  const i18n = useI18n();
  const step2Title = i18n`dlv_safedeal_info_modal_description_2_pt1_seller`;

  return (
    <S.ModalBody data-testid="how-sd-works-modal-body">
      <S.ListItem>
        <S.ListItemImage>
          <MoneyRefund width="32" height="32" viewBox="0 0 96 96" />
        </S.ListItemImage>
        <S.ListItemParagraph>
          <strong>{i18n`dlv_safedeal_info_modal_description_1_pt1_seller`}</strong>{' '}
          {i18n`dlv_safedeal_info_modal_description_1_pt2_seller`}
        </S.ListItemParagraph>
      </S.ListItem>
      <S.ListItem>
        <S.ListItemImage>
          <PackageWithIssue width="32" height="32" viewBox="0 0 130 102" />
        </S.ListItemImage>
        <S.ListItemParagraph>
          <strong>{step2Title}</strong> {i18n`dlv_safedeal_info_modal_description_2_pt2_seller`}
        </S.ListItemParagraph>
      </S.ListItem>
      <S.ListItem>
        <S.ListItemImage>
          <DeliveryVan width="32" height="32" viewBox="0 0 130 100" />
        </S.ListItemImage>
        <S.ListItemParagraph>
          <strong>{i18n`dlv_safedeal_info_modal_description_3_pt1_seller`}</strong>{' '}
          {i18n`dlv_safedeal_info_modal_description_3_pt2_seller`}
        </S.ListItemParagraph>
      </S.ListItem>
      <S.ListItem>
        <S.ListItemImage>
          <HelpLifeline width="32" height="32" viewBox="0 0 120 120" />
        </S.ListItemImage>
        <S.ListItemParagraph>
          <strong>{i18n`dlv_safedeal_info_modal_description_4_pt1_seller`}</strong>{' '}
          {i18n`dlv_safedeal_info_modal_description_4_pt2_seller`}
        </S.ListItemParagraph>
      </S.ListItem>
    </S.ModalBody>
  );
};
